import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OpenSpaceField } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class OpenSpaceFieldService extends InfrastructureService<OpenSpaceField> {
  protected readonly endpoint: string = '/OpenSpaceFields';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
